function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "#355C72",
    style: {
      fill: "#355c72",
      fill: "color(display-p3 .2078 .3608 .4471)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.552 9.207h-1.096a.353.353 0 0 0-.353.353c0 .204.149.353.353.353h1.096c.408 0 .742.334.742.742v1.356H8.706v-1.356c0-.408.334-.742.742-.742h1.096a.353.353 0 0 0 .353-.353.34.34 0 0 0-.353-.353H9.448A1.45 1.45 0 0 0 8 10.655v10.75c0 .8.65 1.45 1.448 1.45h11.104A1.45 1.45 0 0 0 22 21.404v-10.75a1.45 1.45 0 0 0-1.448-1.448m.742 12.199a.745.745 0 0 1-.742.743H9.448a.745.745 0 0 1-.742-.743v-8.69h12.588z",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.456 9.913h5.088a.353.353 0 0 0 .353-.353.34.34 0 0 0-.353-.353h-5.088a.353.353 0 1 0 0 .706m-.946 1.374a.685.685 0 0 0 .686-.687.66.66 0 0 0-.334-.576V8.353A.353.353 0 0 0 11.51 8a.34.34 0 0 0-.353.353v1.67a.66.66 0 0 0-.334.577c0 .39.297.687.687.687m6.98 0a.685.685 0 0 0 .688-.687.66.66 0 0 0-.335-.576V8.353A.353.353 0 0 0 18.492 8c-.204 0-.334.149-.334.353v1.67a.66.66 0 0 0-.335.577c0 .39.297.687.669.687m-7.912 5.7h1.876a.353.353 0 0 0 .353-.353v-1.876a.353.353 0 0 0-.353-.352h-1.875a.35.35 0 0 0-.353.352v1.876c0 .186.167.353.353.353m.354-1.876h1.188V16.3h-1.188zm3.118 1.876h1.875a.353.353 0 0 0 .353-.353v-1.876a.353.353 0 0 0-.353-.352h-1.875a.35.35 0 0 0-.353.352v1.876c.019.186.167.353.353.353m.353-1.876h1.188V16.3h-1.188zm3.138 1.876h1.875a.353.353 0 0 0 .353-.353v-1.876a.353.353 0 0 0-.353-.352h-1.875a.35.35 0 0 0-.353.352v1.876c0 .186.149.353.353.353m.334-1.876h1.188V16.3h-1.188zm-7.298 5.311h1.876a.353.353 0 0 0 .353-.353v-1.875a.353.353 0 0 0-.353-.353h-1.875a.35.35 0 0 0-.353.352v1.876c0 .186.167.353.353.353m.354-1.894h1.188v1.188h-1.188zm3.118 1.894h1.875a.353.353 0 0 0 .353-.353v-1.875a.353.353 0 0 0-.353-.353h-1.875a.35.35 0 0 0-.353.352v1.876c.019.186.167.353.353.353m.353-1.894h1.188v1.188h-1.188zm3.138 1.894h1.875a.353.353 0 0 0 .353-.353v-1.875a.353.353 0 0 0-.353-.353h-1.875a.35.35 0 0 0-.353.352v1.876c0 .186.149.353.353.353m.334-1.894h1.188v1.188h-1.188z",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDate);
export default __webpack_public_path__ + "static/media/ic_date.4cf13e6109efe5222cef8e444904671e.svg";
export { ForwardRef as ReactComponent };